import { FaCaretDown } from "react-icons/fa";
import { PiCaretDown } from "react-icons/pi";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const SimpleDropdownInput3 = ({ value, setValue, placeholder, options }) => {
  console.log("simple gender", { value });
  return (
    <UncontrolledDropdown className="icon-input-3">
      <DropdownToggle
        style={{
          background: "rgba(250, 250, 250, 1)",
          border: "1px solid rgba(220, 220, 220, 0.5)",
          borderRadius: "10px",
        }}
        className="px-2    full-width color-primary-black-2"
      >
        <div className="px-2 py-2 d-flex align-items-center justify-content-between">
          <p className="m-0">
            {Array.isArray(value)
              ? value[0]
              : typeof value === "object"
              ? value?.title ?? value?.name
              : value ?? placeholder}
          </p>
          <div>
            <FaCaretDown size={20} />
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu className="full-width outer-transparent-shadow">
        {options?.map((item, key) => (
          <DropdownItem onClick={() => setValue(item)} key={key}>
            {typeof item === "object" ? item?.title : item}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default SimpleDropdownInput3;
